import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import MaterialIcon from 'material-icons-react';
import ErrorIcon from 'assets/svgs/errorIcon.svg';
import SuccessIcon from 'assets/svgs/successIcon.svg';
import './AlertMessage.scss';

class AlertMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.timeout = null;
    this.removeItself = this.removeItself.bind(this);
    this.showMessage = this.showMessage.bind(this);
  }

  componentDidMount() {
    this.setState({
      show: this.props.show,
    });
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    this.timeout = null;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        show: this.props.show,
      });
    }
  }

  removeItself() {
    this.props.removeMessage();
    clearTimeout(this.timeout);
    this.timeout = null;
    this.setState({
      show: false,
    });
  }

  showMessage() {
    const { time, isError } = this.props;

    if (this.state.show) {
      if (time > 0 && !this.timeout) {
        this.timeout = setTimeout(() => {
          this.removeItself();
        }, time);
      }

      let IconToDisplay = isError ? ErrorIcon : SuccessIcon;
      return (
        <div
          className={`alert-message-container${isError ? ' error' : ''}`}
          {...(this.props.ariaLive ? { 'aria-live': this.props.ariaLive } : {})}
        >
          <div className="alert-message">
            {/*<MaterialIcon icon={isError ? 'report_problem' : 'check_circle_outline'} size="small" />*/}
            <IconToDisplay />
            {this.props.customMessage && (
              <span className="message">{this.props.customMessage}</span>
            )}
            {!this.props.customMessage && (
              <span className="message">
                {this.props.t(this.props.message, this.props.messageParams)}
              </span>
            )}
          </div>
          <IconButton
            className="alert-message-close"
            onClick={this.removeItself}
            aria-label={this.props.t('common.labels.close')}
            size="small"
            sx={{
              color: 'inherit',
              padding: '2px',
              '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.15)' },
            }}>
            <MaterialIcon icon="clear" size="tiny" />
          </IconButton>
        </div>
      );
    }

    return null;
  }

  render() {
    return this.showMessage();
  }
}

AlertMessage.propTypes = {
  time: PropTypes.number,
  isError: PropTypes.bool,
  show: PropTypes.bool,
  // STATEDIST-11174: optional aria-live region politeness level (e.g. "polite"), applied
  // to the outer container only when provided so existing consumers are unaffected.
  ariaLive: PropTypes.string,
  removeMessage: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

AlertMessage.defaultProps = {
  time: 3000,
  isError: false,
};

export default withTranslation()(AlertMessage);
